import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { VesselSpecStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { signalStoreFeature } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { vesselSpecEvents } from './vessel-spec-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withVesselSpecReducer<_>() {
  return signalStoreFeature(
    withTrackedReducer(
      on(
        vesselSpecEvents.fetchVesselSpec,
        (): Partial<VesselSpecStoreState> => ({
          isFetchingVesselSpec: true,
          fetchError: undefined,
        })
      ),
      on(
        vesselSpecEvents.fetchVesselSpecSuccess,
        ({ payload: vesselSpec }): Partial<VesselSpecStoreState> => ({
          vesselSpec,
          isFetchingVesselSpec: false,
        })
      ),
      on(
        vesselSpecEvents.fetchVesselSpecFailed,
        ({ payload: error }): Partial<VesselSpecStoreState> => ({
          vesselSpec: undefined,
          isFetchingVesselSpec: false,
          fetchError: error.message,
        })
      ),
      on(
        vesselSpecEvents.clearVesselSpec,
        (): Partial<VesselSpecStoreState> => ({
          vesselSpec: undefined,
        })
      ),
      on(
        vesselSpecEvents.updateVesselSpec,
        (): Partial<VesselSpecStoreState> => ({
          isUpdatingVesselSpec: true,
          updateError: undefined,
        })
      ),
      on(
        vesselSpecEvents.updateVesselSpecSuccess,
        (): Partial<VesselSpecStoreState> => ({
          isUpdatingVesselSpec: false,
        })
      ),
      on(
        vesselSpecEvents.updateVesselSpecFailed,
        ({ payload: error }): Partial<VesselSpecStoreState> => ({
          isUpdatingVesselSpec: false,
          updateError: error.message,
        })
      )
    )
  );
}
